// ================= SINGLE STAGE COMPRESSOR ENGINE =================

export const createCompressorState = () => ({

  running: false,
  starting: false,
  shuttingDown: false,

  ready: false,
  notReady: true,
  tripped: false,
  permissivePassed: false,

  status: "NOT READY",
  sequenceMessage: "SYSTEM IDLE",

  startSequenceActive: false,
  shutdownSequenceActive: false,
  currentSequenceStep: 0,

  startInterval: null,
  shutdownInterval: null,

  suctionTempAcceptable: "Yes",
  knockoutLevel: "Normal",
  antiSurgeValve: "Open",
  noAlarms: "No",
  lubeOilPressure: "Okay",
  sealOilPressure: "Okay",

  speed: 0,

  PT_suction: 0,
  TT_suction: 0,
  FIC_suction: 0,

  PT_discharge: 0,
  TT_discharge: 0,
  FIC_discharge: 0,

  history: {
  "1h": []
},

 time: [],
PT_suction: [],

  maxHistoryPoints: {
    "1h": 3600
  }
});

// ================= HISTORIAN =================

const pushToHistory = (compressorState) => {

  const point = {
  time: Date.now(),

  PT_suction: Number(compressorState.PT_suction),
  PT_discharge: Number(compressorState.PT_discharge),

  TT_suction: Number(compressorState.TT_suction),
  TT_discharge: Number(compressorState.TT_discharge),

  FIC_suction: Number(compressorState.FIC_suction),
  FIC_discharge: Number(compressorState.FIC_discharge),

  speed: Number(compressorState.speed)
};

  const key = "1h";

  compressorState.history[key].push(point);

  if (
    compressorState.history[key].length >
    compressorState.maxHistoryPoints[key]
  ) {
    compressorState.history[key].shift();
  }
};

// ================= SETTINGS =================

export const compressorSettings = {
  minSuctionPressure: 0.15,
  highAlarm: 0.50,
  lowLowTrip: 0.08
};

export const updateCompressorSettings = (newSettings) => {
  Object.assign(compressorSettings, newSettings);
};

// ================= PERMISSIVES =================

export const checkStartPermissives = (
  compressorState
) => {


  if (
    compressorState.PT_suction <
    compressorSettings.minSuctionPressure
  ) {
    compressorState.sequenceMessage = "LOW SUCTION PRESSURE";
    return false;
  }

  if (compressorState.noAlarms !== "No") {
    compressorState.sequenceMessage = "ACTIVE ALARMS PRESENT";
    return false;
  }

  if (compressorState.antiSurgeValve !== "Open") {
    compressorState.sequenceMessage = "ANTI-SURGE CLOSED";
    return false;
  }

  compressorState.sequenceMessage = "ALL PERMISSIVES SATISFIED";
  return true;
};

// ================= START =================

export const startCompressor = (compressorState) => {

  if (compressorState.tripped) {
    compressorState.status = "TRIPPED";
    return;
  }

  if (
    compressorState.running ||
    compressorState.starting ||
    compressorState.shuttingDown
  ) return;

  if (!checkStartPermissives(compressorState)) {
    compressorState.status = "NOT READY";
    return;
  }

  compressorState.starting = true;
  compressorState.status = "STARTING";

  let step = 0;

  compressorState.startInterval = setInterval(() => {

    step++;
    compressorState.currentSequenceStep = step;

    if (step >= 5) {

      clearInterval(compressorState.startInterval);

      compressorState.starting = false;
      compressorState.running = true;
      compressorState.status = "RUNNING";

      return;
    }

  }, 1500);
};

// ================= STOP =================

export const stopCompressor = (compressorState) => {

  if (!compressorState.running) return;

  compressorState.shuttingDown = true;
  compressorState.status = "SHUTTING DOWN";

  let step = 0;

  compressorState.shutdownInterval = setInterval(() => {

    step++;

    compressorState.speed -= 200;
    if (compressorState.speed < 0) compressorState.speed = 0;

    if (step >= 5) {

      clearInterval(compressorState.shutdownInterval);

      compressorState.running = false;
      compressorState.shuttingDown = false;
      compressorState.status = "STOPPED";

      return;
    }

  }, 1500);
};

// ================= ENGINE UPDATE =================

// ================= ENGINE UPDATE =================

export const updateCompressor = (
  compressorState,
  input = {}
) => {

  if (!compressorState) return;

  const {
  suctionPressure = 0,
  suctionTemperature = 0,
  suctionFlow = 0
} = input;

// ======================================================
// STORE SUCTION VALUES
// ======================================================

compressorState.PT_suction = suctionPressure;

compressorState.TT_suction = suctionTemperature;

compressorState.FIC_suction = suctionFlow;

  // ======================================================
  // LOW LOW TRIP
  // ======================================================

  if (
  suctionPressure <=
  compressorSettings.lowLowTrip
  ) {

    compressorState.tripped = true;

    compressorState.running = false;

    compressorState.starting = false;

    compressorState.shuttingDown = false;

    compressorState.status = "TRIPPED";

    compressorState.sequenceMessage =
      "LOW LOW PRESSURE TRIP";

    return;
  }

  // ======================================================
  // HIGH HIGH TRIP
  // ======================================================

  else if (
  suctionPressure >=
  compressorSettings.highAlarm
  ) {

    compressorState.tripped = true;

    compressorState.running = false;

    compressorState.starting = false;

    compressorState.shuttingDown = false;

    compressorState.status = "TRIPPED";

    compressorState.sequenceMessage =
      "HIGH PRESSURE TRIP";

    return;
  }

  // ======================================================
  // READY LOGIC
  // ======================================================

  if (
    !compressorState.running &&
    !compressorState.starting &&
    !compressorState.shuttingDown &&
    !compressorState.tripped
  ) {

    if (
      checkStartPermissives(
        compressorState
      )
    ) {

      compressorState.status = "READY";

      compressorState.ready = true;

      compressorState.notReady = false;
    }

    else {

      compressorState.status =
        "NOT READY";

      compressorState.ready = false;

      compressorState.notReady = true;
    }
  }

  // ======================================================
  // NOT RUNNING
  // ======================================================

  if (!compressorState.running) return;

  // ======================================================
  // SPEED
  // ======================================================

  compressorState.speed += 50;

  if (
    compressorState.speed > 3600
  ) {

    compressorState.speed = 3600;
  }

  // ======================================================
  // COMPRESSION MODEL
  // ======================================================

  const compressionFactor = 2.8;

  compressorState.PT_discharge =
  suctionPressure * compressionFactor;

compressorState.TT_discharge =
  suctionTemperature + 40;

compressorState.FIC_discharge =
  suctionFlow * 0.98;

  compressorState.status = "RUNNING";

  // ======================================================
  // STORE HISTORY
  // ======================================================

  pushToHistory(compressorState);
};

// ================= SIMULATION =================

export const simulateSingleStageCompressor = ({
  suctionPressure = 0,
  suctionTemperature = 0,
  suctionFlow = 0,
  isRunning = false,
  compressorEfficiency = 0.82,
  compressionRatio = 2.8
}) => {

  if (!isRunning) {
    return {
      dischargePressure: 0.03,
      dischargeTemperature: 25,
      dischargeFlow: 0,
      powerConsumption: 0,
      compressorLoad: 0
    };
  }

  let dischargePressure =
    suctionPressure * compressionRatio * compressorEfficiency;

  let dischargeTemperature =
    suctionTemperature + ((compressionRatio - 1) * 22);

  let dischargeFlow =
    suctionFlow * compressorEfficiency;

  const powerConsumption =
    dischargePressure * dischargeFlow * 0.12;

  const compressorLoad =
    (dischargePressure / compressorSettings.highAlarm) * 100;

  return {
    dischargePressure,
    dischargeTemperature,
    dischargeFlow,
    powerConsumption,
    compressorLoad
  };
};